module.exports = __webpack_public_path__ + "media/images/top/feature_img_02_pc-e0ab08cbb92760bc962f59f46b6fd964.png";